import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {SearchService} from '../../../../../../services/search/search.service';
import {WebsiteContentFaq} from '../../../../../../types/WebsiteContentFaq';

@Component({
  selector: 'app-search-faq',
  templateUrl: './search-faq.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class SearchFaqComponent {
  private searchService = inject(SearchService);
  private websiteContent = this.searchService.websiteContent;
  protected faq = computed<WebsiteContentFaq>(() =>
    this.websiteContent()?.faq ? this.websiteContent()?.faq[0] : null,
  );
}
